import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const CONTRACTTYPEUSAGE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ContractTypeUsage.Name')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ContractTypeUsage.Code')
    .required()
    .maxLength(10)
    .build(),
];

export const CONTRACTTYPEUSAGE_CONFIG = {
  entityName: 'ContractTypeUsage',
  localizationKey: 'Controlling::Entity.ContractTypeUsage',
  fields: CONTRACTTYPEUSAGE_FIELDS,
  permission: 'ControllingContract.ContractTypeUsages',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
